import React from 'react';
import {paths} from '../common/dictionaries/urls';
import CombosList from './components/list/index';
import ComboEdit from './components/edit/index';
import CombosByKatashikies from './components/byKatashikis/index';

export const combosRoutes = [
  {'component': <CombosList />, 'path': paths.CombosList},
  {'component': <ComboEdit />, 'path': paths.ComboEdit},
  {'component': <ComboEdit />, 'path': paths.ComboCreate},
  {'component': <CombosByKatashikies />, 'path': paths.CombosByKatashikies},
];
